import React, { useState, useEffect, useRef } from "react";

const SelectContacts = ({ t }: { t: any }) => {
  const [contactMenuOpen, setContactMenuOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  const toggleContactMenu = () => {
    setContactMenuOpen(!contactMenuOpen);
  };

  const handleClickOutside = (event: MouseEvent) => {
    if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
      setContactMenuOpen(false);
    }
  };

  useEffect(() => {
    if (contactMenuOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [contactMenuOpen]);

  const contacts = [
    {
      icon: "../resources/img/telegram-icon.svg",
      name: "Telegram",
      link: "https://t.me/net_ray",
    },
    {
      icon: "https://i.allo.ua/media/feedbackWidget/icon/feedback_messenger.svg",
      name: "Messenger",
      link: "https://www.messenger.com/e2ee/t/29192731700342038",
    },
    {
      icon: "../resources/img/instagram-icon.svg",
      name: "Instagram",
      link: "https://www.instagram.com/netray_company/",
    },
    // {
    //   icon: "../resources/img/whatsapp-icon.svg",
    //   name: "WhatsApp",
    //   link: "https://wa.me/yourphonenumber",
    // },
    // {
    //   icon: "../resources/img/viber-icon.svg",
    //   name: "Viber",
    //   link: "https://wa.me/yourphonenumber",
    // },
  ];

  return (
    <div className="menu-action" style={{ position: "relative" }} ref={menuRef}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <img
          src="../resources/img/tel.svg"
          alt="Contact Us"
          style={{
            marginRight: "8px",
            width: "20px",
            height: "20px",
            transform: "translateX(-20px)",
          }}
        />
        <button
          className="contact-us-btn"
          style={{ transition: "all 0.3s ease" }}
          onMouseEnter={(e) => (e.currentTarget.style.color = "#ff3535")}
          onMouseLeave={(e) => (e.currentTarget.style.color = "#747474")}
          onClick={toggleContactMenu}
        >
          {t("header.contactUs")}
        </button>
      </div>

      {contactMenuOpen && (
        <div
          className="contact-menu"
          style={{
            position: "absolute",
            top: "100%",
            left: "0",
            backgroundColor: "#fff",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
            zIndex: 1000,
            width: "210px",
            borderRadius: "5px",
            marginTop: "5px",
            padding: "10px 0",
          }}
        >
          <ul style={{ listStyle: "none", margin: 0, padding: 0 }}>
            {contacts.map((contact, index) => (
              <li key={index} style={{ height: "40px" }}>
                <a
                  href={contact.link}
                  target={contact.link.startsWith("http") ? "_blank" : "_self"}
                  rel="noopener noreferrer"
                  style={{
                    textDecoration: "none",
                    fontSize: "14px",
                    color: "#000",
                    display: "flex",
                    alignItems: "center",
                    height: "100%",
                    padding: "0 10px",
                    transition: "background-color 0.2s ease",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.backgroundColor = "#f5f5f5")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.backgroundColor = "transparent")
                  }
                >
                  <img
                    src={contact.icon}
                    alt={contact.name}
                    style={{
                      width: "24px",
                      height: "24px",
                      marginRight: "16px",
                    }}
                  />
                  {contact.name}
                </a>
              </li>
            ))}
          </ul>
          <div
            style={{ textAlign: "left", marginTop: "10px", padding: "0 10px" }}
          >
            <span style={{ fontSize: "12px", color: "#747474" }}>
              {t("header.support")}
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default SelectContacts;
